import React from 'react';

import Image8 from '../../assets/newHeader/award 1.png';
import image17 from '../../assets/newHeader/award 2.png';
import { ReactComponent as Image9 } from '../../assets/newHeader/award 2.svg';
import image18 from '../../assets/newHeader/award 4.png';
// import image19 from '../../assets/newHeader/image17.png';
import vocationalImg from '../../assets/newHeader/vocational-img.png';

type VocationalPageProps = {
  imagePosition?: 'left' | 'right';
  image?: string;
};

export const VovationalPage: React.FC<VocationalPageProps> = ({
  imagePosition = 'right',
  image,
}) => {
  const isImageLeft = imagePosition === 'left';

  return (
    <section className="flex items-center justify-center bg-white py-16">
      <div className="container">
        <div className="flex flex-col lg:flex-row items-center justify-between gap-10 max-w-6xl mx-auto">
          {/* Text Section */}
          <div className="text-center lg:text-left">
            <p className="text-2xl mb-2">As Seen In</p>
            <h3 className="text-3xl sm:text-5xl md:text-6xl !leading-snug mb-6">
              #1 Vocational
              <br className="hidden md:block" />
              <span className="text-primary-500 font-bold">Education Startup</span>
              <br className="hidden md:block" />
              in the U.S. – F6S
            </h3>

            {/* Logos */}
            <div className="flex flex-wrap gap-6 justify-center lg:justify-start max-w-lg mt-8">
              <img src={Image8} alt="Nasdaq logo" className="h-16 md:h-20 object-contain" />
              <img src={image17} alt="Nasdaq logo" className="h-16 md:h-20 object-contain" />
              <Image9 className="w-40 md:w-44 object-contain md:mt-12 " />
              <img src={image18} alt="Forbes logo" className="h-36 md:h-40 object-contain" />
            </div>
          </div>

          {/* Optional Image Right */}
          {!isImageLeft && (
            <div className="w-full max-w-sm lg:max-w-md">
              <ImageBlock image={image} />
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

// ✅ Now accepts props correctly
const ImageBlock: React.FC<{ image?: string }> = ({ image }) => (
  <div className="">
    <img src={image || vocationalImg} alt="vocationalImg" className="" />
  </div>
);
